import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FONT_FAMILY } from 'common/sharedFunctions';

// Tarjeta KPI moderna: icono en circulo translucido + titulo + valor.
// Mantiene compatibilidad con crdStyle (color de fondo, radio) usado en Dashboard.
export default function DashboardCard(props) {
  const { title, children, icon, subtitle, crdStyle, className } = props;

  return (
    <Card
      className={className}
      style={{
        borderRadius: 18,
        padding: '18px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        minHeight: 104,
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        ...crdStyle,
      }}
    >
      {icon ?
        <Box
          sx={{
            width: 54, height: 54, borderRadius: '14px',
            backgroundColor: 'rgba(255,255,255,0.18)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        : null}
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Typography style={{ fontFamily: FONT_FAMILY, fontSize: 13, opacity: 0.85, color: 'inherit', letterSpacing: 0.4 }}>
          {title}
        </Typography>
        <Typography style={{ fontFamily: FONT_FAMILY, fontSize: 24, fontWeight: 800, color: 'inherit', lineHeight: 1.2 }}>
          {children}
        </Typography>
        {subtitle ?
          <Typography style={{ fontFamily: FONT_FAMILY, fontSize: 12, opacity: 0.8, color: 'inherit', marginTop: 2 }}>
            {subtitle}
          </Typography>
          : null}
      </Box>
    </Card>
  );
}
